import { useCallback } from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { RaRecord, useDelete } from 'react-admin';

import { BOResourceAll } from '@Common/types/bo_external/resources';

type SafeDeleteFn<Res extends RaRecord> = (
  resource: BOResourceAll,
  params: { id: number | string; previousData?: Res },
) => Promise<Res>;

export function useDeletePromise<Res extends RaRecord = RaRecord>(): [
  SafeDeleteFn<Res>,
  { isLoading: boolean; isError: boolean },
] {
  const [deleteFn, { isLoading, isError }] = useDelete();
  const safeDelete = useCallback(
    async (resource: BOResourceAll, params: { id: number | string; previousData?: Res }) =>
      new Promise<Res>((resolve, reject) => {
        deleteFn(resource, params, {
          onSettled: (data, error) => {
            if (error) {
              reject(error);
            } else {
              resolve(data);
            }
          },
        });
      }),
    [deleteFn],
  );

  return [safeDelete, { isLoading, isError }];
}
